import { Grid } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import { selectRows } from "../../../../../store/selectors/fieldsStateSelectors";
import Settings from "./Settings";
import TextField from "./TextField";

export default function SettingsContainer({ readonlyMode }: { readonlyMode: boolean }) {
  const rowsAreaValues = useSelector(selectRows);

  const fieldDescriptors = useMemo(() => getFieldDescriptors(rowsAreaValues), [rowsAreaValues]);

  return (
    <ScrollableFlexContainer>
      <Grid container sx={{ gap: ".5rem", px: "1.3rem", width: "100%" }}>
        <Settings readonlyMode={readonlyMode} />
        <Grid container sx={{ gap: ".5rem", flex: 1, width: "100%" }}>
          {fieldDescriptors.map((descriptor) => (
            <TextField key={descriptor.field.meta.name} field={descriptor.field} readonlyMode={readonlyMode} />
          ))}
        </Grid>
      </Grid>
    </ScrollableFlexContainer>
  );
}

function getFieldDescriptors(values: ReportField[]) {
  const fieldDescriptors = values
    .map((field, index) => {
      const isLeaf = index === values.length - 1;
      return { field, isLeaf };
    })
    .filter((field) => !field.isLeaf);
  return fieldDescriptors;
}
